module.exports = __webpack_public_path__ + "img/hazel.a07d7353.svg";